exports.tableFormat = {
  headerLabels: [
    "Request ID",
    "Customer",
    "UAT ID",
    "TPID",
    "Request Date",
    "Request Status",
    "GPU",
    "# of GPUs Requested",
    "Region Requested",
    "Region Flexibility",
    "Date Needed",
    "# GPUs Allocated",
    "GPUs Owed",
    "DC Region(Allocated)",
    "RI",
    "Earmarked Date",
    "Fully Allocated Date",
    "Tag",
    "AI GBB",
    "MSX  Opportunity ID",
    "MSX  Milestone ID",
    "Lost Reason",
    "Lost to (Competitor)",
    "Use Case Category",
  ],
  keys: [
    "RequestCode",
    "CustomerName",
    "UAT_ID",
    "TPID",
    "RequestDate",
    "RequestStatus",
    "GPU_Name",
    "GPUsRequested",
    "RegionNeeded",
    "RegionFlexibility",
    "DateNeeded",
    "GPUsAllocated",
    "GPUsOwed",
    "DC_RegionAllocated",
    "RI",
    "EarmarkedDate",
    "FullyAllocatedDate",
    "Tag",
    "AIGBB",
    "MSX_Opportunity_ID",
    "MSX_Milestone_ID",
    "LostReason",
    "LostToCompetitor",
    "UseCaseCategory",
  ],
  LabelKeyPair: [
    { label: "Request ID", key: "RequestCode" },
    { label: "Customer", key: "CustomerName" },
    { label: "UAT ID", key: "UAT_ID" },
    { label: "TPID", key: "TPID" },
    { label: "Request Date", key: "RequestDate" },
    { label: "Request Status", key: "RequestStatus" },
    { label: "GPU", key: "GPU_Name" },
    { label: "# of GPUs Requested", key: "GPUsRequested" },
    { label: "Region Requested", key: "RegionNeeded" },
    { label: "Region Flexibility", key: "RegionFlexibility" },
    { label: "Date Needed", key: "DateNeeded" },
    { label: "# GPUs Allocated", key: "GPUsAllocated" },
    { label: "GPUs Owed", key: "GPUsOwed" },
    { label: "DC Region(Allocated)", key: "DC_RegionAllocated" },
    { label: "RI", key: "RI" },
    { label: "Earmarked Date", key: "EarmarkedDate" },
    { label: "Fully Allocated Date", key: "FullyAllocatedDate" },
    { label: "Tag", key: "Tag" },
    { label: "AI GBB", key: "AIGBB" },
    { label: "MSX  Opportunity ID", key: "MSX_Opportunity_ID" },
    { label: "MSX  Milestone ID", key: "MSX_Milestone_ID" },
    { label: "Lost Reason", key: "LostReason" },
    { label: "Lost to (Competitor)", key: "LostToCompetitor" },
    { label: "Use Case Category", key: "UseCaseCategory" },
  ],

  GPUsBulkUpdate: [
    { label: "Request ID", key: "RequestCode" },
    { label: "Customer", key: "CustomerName" },
    { label: "UAT ID", key: "UAT_ID" },
    { label: "TPID", key: "TPID" },
    { label: "Request Date", key: "RequestDate" },
    { label: "GPU", key: "GPU_Name" },
    { label: "# of GPUs Requested", key: "GPUsRequested" },
    { label: "Region Requested", key: "RegionNeeded" },
    { label: "Region Flexibility", key: "RegionFlexibility" },
    { label: "Date Needed", key: "DateNeeded" },
    { label: "RI", key: "RI" }
  ],
};

